import { z } from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod/dist/zod";
import { Form } from "../../forms/components/Form";
import { FormRow } from "../../forms/components/FormRow";
import { TextArea } from "../../forms/components/TextArea";
import { t } from "i18next";
import { Trans } from "react-i18next";
import { Button } from "../../ui/components/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStop } from "@fortawesome/free-solid-svg-icons";
import { KeyboardEventHandler, useContext, useEffect, useState } from "react";
import { ChatbotStateContext } from "../utils/chatbotContext";
import { useWebSocketContext } from "../utils/chatbotWSContext";


export const ChatbotQuestionForm = () => {

  const chatbotCurrentState = useContext(ChatbotStateContext);
  const { stopWebSocketStream, submitQuestionToWebSocket } = useWebSocketContext();

  const [isStreaming, setIsStreaming] = useState(false);
  useEffect(() => {
    setIsStreaming(chatbotCurrentState?.isStreaming ? chatbotCurrentState?.isStreaming : false);
  }, [chatbotCurrentState.isStreaming]);

  const schema = z.object({
    question: z.string()
      .max(1000),
  });

  type Schema = z.infer<typeof schema>;

  const methods = useForm<Schema>({
    resolver: zodResolver(schema),
    defaultValues: {
      question: "",
    },
  });

  const { register, handleSubmit, reset } = methods;

  // Submit btn was clicked
  const submitQuestion = (data: Schema) => {
    submitQuestionToWebSocket(data.question, chatbotCurrentState.selectedBrand, chatbotCurrentState.selectedRole);
    reset();
  };

  // User clicks Enter Key
  const onKeyDown: KeyboardEventHandler<HTMLTextAreaElement> = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      handleSubmit((data) => {
        submitQuestion({
          question: data.question,
        });
        reset();
      })();
    }
  };

  // Stop WebSocket Stream
  const handleStop = () => {
    stopWebSocketStream();
  };

  return (
    <div className="min-h-[8rem] flex flex-col justify-center">
      <Form {...methods} onSubmit={submitQuestion}>
        {!isStreaming && (
          <div className="flex flex-wrap pl-4">
            <div className="w-full">
              <FormRow>
                <div className="flex w-full">
                  <TextArea
                    className="flex-grow"
                    label={t`Ask me anything`}
                    {...register("question")}
                    onKeyDown={onKeyDown}
                    disabled={chatbotCurrentState.currentState !== "Connected State"}
                  />
                  <div className="flex flex-col justify-center items-center p-4">
                    <Button type="submit" title={t`Submit`} className="mx-auto" disabled={chatbotCurrentState.currentState !== "Connected State"}>
                      <Trans>Submit</Trans>
                    </Button>
                  </div>
                </div>
              </FormRow>
            </div>
          </div>
        )}
      </Form>
      {isStreaming && (
        <div className="flex w-full flex-col justify-center items-center p-4">
          <Button type="button" title={t`Stop`} className="mx-auto" onClick={handleStop}>
            <FontAwesomeIcon icon={faStop} />
            <span className="ml-2"><Trans>STOP</Trans></span>
          </Button>
        </div>
      )}
    </div>
  );
};
